import { TradeTabsType } from 'common/types';

export const AXIOS_INTERCEPTOR_EVENT_NAME = 'axios_intercept_error';
export const MOBILE_TRADE_TAB_LS_KEY = 'webtrader.storage.trade-menu.last-selected';

export const DEFAULT_TRADE_TAB: TradeTabsType = 'spot';

export const BTC_EUR_PAIR = 'BTC-EUR';
